export enum StateLayerEnum {
    NO_DATA,
    OTHER,
    NATIONAL_IMAGE,
    SECURITY_OF_PERSONAL_DATA_OF_CITIZENS,
    FUNCTIONING_OF_THE_GOVERNMENT,
    ECONOMIC_STABILITY,
    NATIONAL_SECURITY
}
